"use strict";

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteLeftSidebar = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _flex = _interopRequireDefault(require("@waglabs/flex"));

var _box = _interopRequireDefault(require("@waglabs/box"));

var _button = _interopRequireDefault(require("@waglabs/button"));

var _icon = _interopRequireDefault(require("@waglabs/icon"));

var _text = _interopRequireDefault(require("@waglabs/text"));

var _link = _interopRequireDefault(require("@waglabs/link"));

var _constants = require("../constants");

var _urls = require("../urls");

var _helper = require("../utils/helper");

var _SidebarItemNested = require("./components/SidebarItemNested");

var _SidebarItem = require("./components/SidebarItem");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var routes = _helper.helper.attachQueryStringToRoutes([_objectSpread({}, _urls.servicesLinksData, {
  style: {
    border: '1px solid rgb(237, 237, 237)'
  }
}), _objectSpread({}, _urls.safetyLinksData, {
  style: {
    border: '1px solid rgb(237, 237, 237)',
    mb: '15px'
  }
}), _objectSpread({}, _urls.wagTagLinksData, {
  key: _urls.wagTagLinksData.url
}), _objectSpread({}, _urls.helpCenterLinkData, {
  key: _urls.helpCenterLinkData.url
}), _objectSpread({}, _urls.dailyWagLinkData, {
  key: _urls.dailyWagLinkData.url
})]);

var SiteLeftSidebar = function SiteLeftSidebar(_ref) {
  var open = _ref.open,
      rest = _objectWithoutProperties(_ref, ["open"]);

  return _reactDom["default"].createPortal(_react["default"].createElement(_flex["default"], _extends({
    bg: "white",
    boxSizing: "border-box",
    flexDirection: "column",
    height: ["calc(100vh - ".concat(_constants.SITE_HEADER_MOBILE_HEIGHT, "px)"), "calc(100vh - ".concat(_constants.SITE_HEADER_TABLET_HEIGHT, "px)")],
    left: open ? 0 : -250,
    overflow: "scroll",
    position: "fixed",
    top: [_constants.SITE_HEADER_MOBILE_HEIGHT, _constants.SITE_HEADER_TABLET_HEIGHT],
    transition: "0.2s ease-in-out left",
    width: 250,
    zIndex: 2
  }, rest), routes.map(function (route) {
    return _react["default"].createElement(_flex["default"], {
      key: route.key,
      flexDirection: "column",
      boxSizing: "border-box",
      borderColor: "backgroundGray"
    }, Array.isArray(route.subRoutes) && route.subRoutes.length ? _react["default"].createElement(_SidebarItemNested.SidebarItemNested, _extends({
      route: route
    }, route.style)) : _react["default"].createElement(_SidebarItem.SidebarItem, {
      route: route
    }));
  }), _react["default"].createElement(_box["default"], {
    p: 2,
    pt: 3
  }, _react["default"].createElement(_link["default"], {
    href: _urls.becomeAWalkerLinkData.url
  }, _react["default"].createElement(_button["default"], {
    hover: true,
    variant: "primary",
    width: 1
  }, _react["default"].createElement(_flex["default"], {
    hover: true,
    alignItems: "center"
  }, _react["default"].createElement(_icon["default"], {
    hover: true,
    mr: 2,
    name: "walker"
  }), _react["default"].createElement(_text["default"], {
    hover: true,
    color: "darkRed",
    fontFamily: "body",
    fontSize: 2,
    m: 0,
    textTransform: "uppercase"
  }, _urls.becomeAWalkerLinkData.label)))))), document.body);
};

exports.SiteLeftSidebar = SiteLeftSidebar;